module.exports = __webpack_public_path__ + "img/c.86045274.jpg";